module.exports = __webpack_public_path__ + "img/swiper_6.ca689b8e.png";